// Generic in-flight + just-settled dedup for axios GETs. Prevents the
// classic "API called twice" bug caused by React.StrictMode double-mount,
// fast remounts, or two components subscribing at once. Keeps the
// resolved promise around for SETTLE_HOLD_MS after it settles so a
// second caller arriving milliseconds later still reuses it.

const SETTLE_HOLD_MS = 1500;
const _inFlight = new Map();

export const dedupedGet = (key, axiosCall) => {
  const existing = _inFlight.get(key);
  if (existing) return existing;
  const p = axiosCall().finally(() => {
    setTimeout(() => {
      if (_inFlight.get(key) === p) {
        _inFlight.delete(key);
      }
    }, SETTLE_HOLD_MS);
  });
  _inFlight.set(key, p);
  return p;
};
